import { Column, COLUMN_CELL_TYPE, Filter } from '@/components/table/base'
import { DATE_FORMAT } from '@/constants/dateFormat'
import { Whitelisting } from '@/types/streams/whitelisting'

export const WHITELISTING_TABLE_COLUMNS: Column<Whitelisting>[] = [
  {
    id: 'id',
    label: 'ID',
    type: COLUMN_CELL_TYPE.NUMBER,
    sx: { width: 150 },
    sortAttribute: 'id'
  },
  {
    id: 'cidrRange',
    label: 'IP Address',
    type: COLUMN_CELL_TYPE.TEXT,
    sortAttribute: 'cidrRange'
  },
  {
    id: 'classification',
    label: 'Classification',
    type: COLUMN_CELL_TYPE.TEXT,
    sortAttribute: 'classification'
  },
  {
    id: 'comment',
    label: 'Description',
    type: COLUMN_CELL_TYPE.TEXT,
    sortAttribute: 'comment'
  },
  {
    id: 'createdAt',
    label: 'Created At',
    type: COLUMN_CELL_TYPE.DATE,
    dateFormat: DATE_FORMAT.DATE_AND_TIME,
    sortAttribute: 'createdAt',
    sx: { whiteSpace: 'nowrap' }
  }
]

export const WHITELISTING_TABLE_FILTERS: Filter<Whitelisting>[] = [
  {
    type: 'freeTextSearch',
    paramName: 'filter',
    placeholder: 'Search',
    filterOptions: (row, search) => {
      if (!search) return true

      const lowerCaseSearch = search.toLowerCase()
      const { cidrRange, id, classification, comment } = row

      return (
        cidrRange.toLowerCase().includes(lowerCaseSearch) ||
        id.toString().toLowerCase().includes(lowerCaseSearch) ||
        classification.toLowerCase().includes(lowerCaseSearch) ||
        comment.toLowerCase().includes(lowerCaseSearch)
      )
    }
  }
]
